/* eslint-disable import/first */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store/index'
import { storage } from './store/local'
import { http } from './utils/http'
import { request } from './utils/request'
import global from './utils/global'
import filters from '@/filters'
import Directives from './directives/index'
import vConsole from './lib/vconsole.js'
import { getUA } from './utils/index'
import cst from './store/const'
import './styles/tailwindcss.css'

// import 'amfe-flexible/index.js'
import 'lib-flexible'

import Vant, { Lazyload } from 'vant'
import 'vant/lib/index.css'
import { monitorOriginal } from './utils/monitor'

import App from './App' // 在vant后引入 防止样式覆盖

Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(filters)
Vue.use(Directives)
Vue.use(vConsole)

Vue.prototype.$http = http
Vue.prototype.$request = request
Vue.prototype.$global = global
Vue.prototype.$local = storage
Vue.prototype.$cst = cst
Vue.prototype.$UA = getUA()
console.log('UA::: ', getUA())

Vue.config.productionTip = false
Vue.config.devtools = true

monitorOriginal()

const vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

export default vue



// WEBPACK FOOTER //
// ./src/main.js